import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { businessService } from "./business.service";

const initialState = {
    business: null,
    isLoading: false,
    error: null,
    success: false,
    message: "",
};

export const fetchBusiness = createAsyncThunk(
    "business/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await businessService.getBusiness();
            return response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch business details"
            );
        }
    }
);

export const updateBusiness = createAsyncThunk(
    "business/update",
    async (data, { rejectWithValue }) => {
        try {
            const response = await businessService.updateBusiness(data);
            return response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to update business details"
            );
        }
    }
);

const businessSlice = createSlice({
    name: "business",
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.error = null;
            state.success = false;
            state.message = "";
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Business
            .addCase(fetchBusiness.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchBusiness.fulfilled, (state, action) => {
                state.isLoading = false;
                state.business = action.payload?.data || null;
                state.error = null;
            })
            .addCase(fetchBusiness.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            // Update Business
            .addCase(updateBusiness.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateBusiness.fulfilled, (state, action) => {
                state.isLoading = false;
                state.business = action.payload?.data || state.business;
                state.success = true;
                state.message = action.payload?.message || "Business updated successfully";
                state.error = null;
            })
            .addCase(updateBusiness.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.success = false;
            });
    },
});

export const { reset } = businessSlice.actions;
export default businessSlice.reducer;
